module.exports = __webpack_public_path__ + "img/5a17ae58.png";